module.exports = __webpack_public_path__ + "static/media/logo-brown-beta.01ddbffa.png";